(() => {
  const root = document.documentElement;
  root.dataset.homeMotion = "enhanced";

  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const revealSelector = "[data-home-reveal]";
  const heroSelector = "[data-home-hero]";

  const markVisible = (element) => {
    if (!element) return;
    element.classList.add("is-visible");
  };

  const initializeHero = () => {
    document.querySelectorAll(heroSelector).forEach((hero) => {
      requestAnimationFrame(() => markVisible(hero));
    });
  };

  const initializeReveals = () => {
    const elements = Array.from(document.querySelectorAll(revealSelector));
    if (!elements.length) return;

    if (prefersReducedMotion) {
      elements.forEach(markVisible);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          markVisible(entry.target);
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.18,
        rootMargin: "0px 0px -10% 0px",
      }
    );

    elements.forEach((element) => observer.observe(element));
  };

  const initialize = () => {
    initializeHero();
    initializeReveals();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener("shopify:section:load", () => {
    initialize();
  });
})();
